import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'Ad/GetPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'Ad/Save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'Ad/Delete',
    method: 'post',
    data,
  })
}